export const talentsBatch30 = [
  // ==================== 第二十四批：项目管理与测试类（11位）====================
  // ID 236 (贾天翔, 高级项目经理) removed - duplicate of ID 230 in batch29
  // ID 237 (伊清雅, 项目协调专员) removed - duplicate of ID 231 in batch29
  // ID 241 (晏静怡, 测试验证专员) removed - duplicate of ID 206 in batch32
  {
    id: 239,
    name: '鲁思远',
    role: '工作室运营',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20creative%20studio%20operations%20manager%20in%20smart%20business%20attire%20analytical%20expression%20age%2033%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-004&orientation=portrait',
    salary: '¥2000/月',
    tags: ['工作室运营', '效率分析', '工具选型', '流程优化', '知识沉淀', '团队效能'],
    description: '创意工作室日常运营管理专家，擅长团队效率数据分析和工具选型，提升工作室运营效能。',
    skills: [
      { name: '团队效率分析', level: 96 },
      { name: '工具选型能力', level: 95 },
      { name: '流程优化能力', level: 97 },
      { name: '知识沉淀管理', level: 94 },
      { name: '运营数据分析', level: 93 },
    ],
    performance: {
      efficiency_improvement: '+55%',
      cost_reduction: '30%',
    },
    cases: [
      {
        title: '某设计工作室运营优化',
        result: '全面优化工作室运营，选型并实施协作工具，优化工作流程，团队效率提升60%，项目交付周期缩短40%',
        duration: '6个月',
        tags: ['运营优化', '工具实施', '效率提升', '周期缩短'],
      },
      {
        title: '某创意公司知识管理',
        result: '建立知识管理体系，沉淀项目经验和创意素材，新人培训周期从4周缩短至2周，创意复用率提升70%',
        duration: '4个月',
        tags: ['知识管理', '经验沉淀', '培训缩短', '复用提升'],
      },
      {
        title: '某工作室成本控制',
        result: '分析运营成本，优化资源配置和工具采购，年度运营成本降低30%，利润率提升25%',
        duration: '3个月',
        tags: ['成本控制', '资源优化', '成本降低', '利润提升'],
      },
    ],
    reviews: [
      {
        name: '苗工作室创始人',
        company: '某设计工作室',
        rating: 5,
        content: '鲁思远的运营优化能力非常强，他选型的工具很好用，优化的流程很合理。他的优化让我们的效率提升了60%，交付更快了。',
        date: '2024-01-30',
      },
      {
        name: '祁创意总监',
        company: '某创意公司',
        rating: 5,
        content: '他建立的知识管理体系非常实用，项目经验和素材都沉淀下来了。他的管理让新人培训周期缩短了一半，创意复用率也提升了。',
        date: '2024-02-22',
      },
      {
        name: '宿合伙人',
        company: '某工作室',
        rating: 5,
        content: '他的成本分析很专业，优化建议都很实用。他的优化让我们的运营成本降低了30%，利润率提升了25%。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '工作室运营专家，专注于通过数据分析和流程优化提升工作室运营效能',
        personality: '数据驱动、善于优化、注重效率、系统思维强，能够发现并解决运营中的问题',
        background: '运营管理或相关专业背景，精通数据分析、流程优化、工具选型，熟悉创意行业运营',
      },
      mission: {
        duties: '负责团队效率数据分析、工具选型、流程优化、知识沉淀、运营成本控制',
        goals: '提升工作室运营效能，效率提升50%以上，成本降低20%以上',
        collaboration: '与团队成员收集反馈，与管理层汇报数据，与供应商对接工具',
      },
      delivery: {
        example: '输出效率分析报告、工具选型方案、流程优化方案、知识库、运营报告',
        workflow: '1.数据收集 → 2.效率分析 → 3.问题识别 → 4.方案设计 → 5.工具选型 → 6.流程优化 → 7.效果评估',
        format: '提供分析报告、选型方案、优化文档、知识库、运营报告等标准化交付物',
      },
      metrics: {
        quality: '效率提升幅度、成本降低幅度、工具使用率、流程优化效果、团队满意度',
        acceptance: '效率显著提升，成本有效降低，工具使用顺畅，流程优化到位，团队满意',
        improvement: '持续监控运营数据，优化工作流程，完善知识管理，探索新工具',
      },
    },
  },
  {
    id: 240,
    name: '解博文',
    role: 'Jira管理员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20Jira%20workflow%20specialist%20in%20tech%20business%20casual%20attire%20technical%20expression%20age%2030%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-005&orientation=portrait',
    salary: '¥1750/月',
    tags: ['Jira配置', '工作流定制', '自动化规则', '看板报表', '项目模板', '敏捷工具'],
    description: 'Jira配置与工作流优化专家，擅长项目模板设置和工作流自定义，提升团队协作效率。',
    skills: [
      { name: '项目模板设置', level: 96 },
      { name: '工作流自定义', level: 97 },
      { name: '自动化规则配置', level: 95 },
      { name: '看板报表配置', level: 94 },
      { name: 'Jira管理能力', level: 93 },
    ],
    performance: {
      jira_instances: 25,
      efficiency_improvement: '+50%',
    },
    cases: [
      {
        title: '某软件公司Jira体系搭建',
        result: '搭建完整Jira项目管理体系，配置10+项目模板，20+工作流，团队协作效率提升55%，需求追踪准确率99%',
        duration: '3个月',
        tags: ['Jira搭建', '模板配置', '效率提升', '追踪准确'],
      },
      {
        title: '某敏捷团队工作流优化',
        result: '优化敏捷团队Jira工作流，配置自动化规则50+条，手工操作减少70%，Sprint交付效率提升40%',
        duration: '2个月',
        tags: ['工作流优化', '自动化', '操作减少', '交付提升'],
      },
      {
        title: '某企业Jira报表定制',
        result: '定制Jira看板和报表，实时展示项目进度和团队效能，管理决策效率提升60%，问题响应速度提升50%',
        duration: '1个月',
        tags: ['报表定制', '实时展示', '决策提升', '响应加快'],
      },
    ],
    reviews: [
      {
        name: '双技术总监',
        company: '某软件公司',
        rating: 5,
        content: '解博文的Jira配置能力非常专业，他搭建的项目管理体系很完善。他的配置让我们的团队协作效率提升了55%，需求追踪更准确了。',
        date: '2024-01-30',
      },
      {
        name: '方敏捷教练',
        company: '某敏捷团队',
        rating: 5,
        content: '他优化的工作流非常合理，配置的自动化规则大大减少了手工操作。他的优化让我们的Sprint交付效率提升了40%。',
        date: '2024-02-22',
      },
      {
        name: '孔项目总监',
        company: '某企业',
        rating: 5,
        content: '他定制的看板和报表非常实用，项目进度和团队效能一目了然。他的报表让我们的管理决策效率提升了60%。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: 'Jira工作流管理专家，专注于通过Jira配置和优化提升团队协作效率',
        personality: '技术扎实、注重效率、善于配置、服务意识强，能够根据团队需求定制Jira方案',
        background: '计算机或项目管理专业背景，精通Jira配置、工作流设计、自动化规则，熟悉敏捷和Scrum方法论',
      },
      mission: {
        duties: '负责项目模板设置、工作流自定义、自动化规则、看板/报表配置、Jira培训',
        goals: '提升团队协作效率，效率提升50%以上，自动化覆盖率达到70%以上',
        collaboration: '与项目团队确认需求，与开发团队配置集成，与管理层展示报表',
      },
      delivery: {
        example: '输出Jira配置方案、项目模板、工作流配置、自动化规则、看板报表',
        workflow: '1.需求分析 → 2.模板设计 → 3.工作流配置 → 4.自动化规则 → 5.看板报表 → 6.测试验证 → 7.培训推广',
        format: '提供配置文档、模板文件、工作流图、规则列表、使用手册等标准化交付物',
      },
      metrics: {
        quality: '配置合理性、自动化覆盖率、团队使用率、效率提升幅度、用户满意度',
        acceptance: '配置合理，自动化有效，团队使用顺畅，效率显著提升，用户满意',
        improvement: '持续优化配置，扩展自动化，完善报表，提供培训支持',
      },
    },
  },
  {
    id: 242,
    name: '郗晨阳',
    role: '质量保障工程师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20production%20readiness%20assessor%20in%20formal%20business%20attire%20serious%20professional%20expression%20age%2033%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-007&orientation=portrait',
    salary: '¥2125/月',
    tags: ['上线检查', '风险评分', '验证测试', '发布决策', '质量关卡', '生产就绪'],
    description: '生产就绪评估与质量关卡专家，擅长上线前检查清单和风险评分，确保产品安全上线。',
    skills: [
      { name: '上线前检查', level: 97 },
      { name: '风险评分能力', level: 96 },
      { name: '验证测试能力', level: 95 },
      { name: '发布决策建议', level: 94 },
      { name: '质量把关能力', level: 98 },
    ],
    performance: {
      releases_assessed: 120,
      production_incident_rate: '0.5%',
    },
    cases: [
      {
        title: '某金融系统上线评估',
        result: '执行严格的上线前检查，发现并修复15个高风险问题，系统安全上线，运行1年零重大故障',
        duration: '1个月',
        tags: ['金融系统', '上线评估', '风险发现', '零故障'],
      },
      {
        title: '某电商平台大促发布',
        result: '评估大促版本发布风险，建议延期修复3个关键问题，避免了潜在的系统崩溃，大促期间系统稳定',
        duration: '2周',
        tags: ['大促发布', '风险评估', '决策建议', '系统稳定'],
      },
      {
        title: '某企业发布流程优化',
        result: '建立标准化上线检查流程，制定风险评分模型，生产事故率从5%降至0.5%，发布质量大幅提升',
        duration: '3个月',
        tags: ['流程优化', '标准化', '事故降低', '质量提升'],
      },
    ],
    reviews: [
      {
        name: '双技术总监',
        company: '某金融科技公司',
        rating: 5,
        content: '郗晨阳的上线评估非常严格，他发现的问题都很关键。他的把关让我们的系统安全上线，运行一年都没出过重大故障。',
        date: '2024-01-30',
      },
      {
        name: '方运维总监',
        company: '某电商平台',
        rating: 5,
        content: '他的风险评估非常专业，建议我们延期修复关键问题。他的决策建议避免了大促期间的系统崩溃，非常感谢他。',
        date: '2024-02-22',
      },
      {
        name: '孔CTO',
        company: '某企业',
        rating: 5,
        content: '他建立的上线检查流程非常标准化，风险评分模型也很科学。他的工作让我们的生产事故率降低了90%。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '生产就绪评估专家，专注于通过严格的质量关卡确保产品安全上线',
        personality: '严谨细致、风险意识强、原则性强、责任心重，能够在压力下坚持质量标准',
        background: '软件工程或质量管理专业背景，精通质量管理、风险评估、测试方法，熟悉生产环境和发布流程',
      },
      mission: {
        duties: '负责上线前检查清单、风险评分、验证测试、发布决策建议、质量把关',
        goals: '确保产品安全上线，生产事故率控制在1%以内，重大故障零容忍',
        collaboration: '与测试团队协作验证，与开发团队确认修复，与管理层提供决策建议',
      },
      delivery: {
        example: '输出上线检查清单、风险评分报告、验证测试报告、发布决策建议、质量评估',
        workflow: '1.检查清单制定 → 2.上线前检查 → 3.风险评分 → 4.验证测试 → 5.问题跟踪 → 6.决策建议 → 7.发布确认',
        format: '提供检查清单、风险报告、测试报告、决策建议、质量评估等标准化交付物',
      },
      metrics: {
        quality: '问题发现率、风险评估准确性、生产事故率、发布质量、决策准确性',
        acceptance: '问题发现全面，风险评估准确，生产事故率低，发布质量高，决策合理',
        improvement: '持续完善检查清单，优化风险模型，提升评估能力，建立质量标准',
      },
    },
  },
  {
    id: 243,
    name: '禹泽宇',
    role: 'API测试员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20API%20testing%20specialist%20in%20tech%20casual%20attire%20technical%20expression%20age%2031%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-008&orientation=portrait',
    salary: '¥1625/月',
    tags: ['API测试', '接口测试', '自动化测试', '响应断言', '性能监控', 'Postman'],
    description: 'API接口测试与集成验证专家，擅长接口用例生成和自动化测试执行，确保API质量和稳定性。',
    skills: [
      { name: '接口用例生成', level: 96 },
      { name: '自动化测试执行', level: 97 },
      { name: '响应断言能力', level: 95 },
      { name: '性能监控能力', level: 94 },
      { name: 'API测试工具', level: 93 },
    ],
    performance: {
      daily_test_cases: 150,
      api_coverage: '95%',
    },
    cases: [
      {
        title: '某电商平台API测试体系',
        result: '搭建完整API测试体系，编写测试用例2000+条，API覆盖率95%，接口问题发现率提升70%，生产故障率降低80%',
        duration: '3个月',
        tags: ['测试体系', '高覆盖率', '问题发现', '故障降低'],
      },
      {
        title: '某金融系统接口自动化',
        result: '实现核心接口自动化测试，每日自动执行500+用例，测试效率提升10倍，回归测试时间从2天缩短至2小时',
        duration: '2个月',
        tags: ['接口自动化', '效率提升', '回归加速', '时间缩短'],
      },
      {
        title: '某SaaS产品API性能监控',
        result: '建立API性能监控体系，实时监控接口响应时间，提前发现性能问题10+个，系统性能稳定优秀',
        duration: '1个月',
        tags: ['性能监控', '实时监控', '问题预警', '性能稳定'],
      },
    ],
    reviews: [
      {
        name: '孔技术总监',
        company: '某电商平台',
        rating: 5,
        content: '禹泽宇的API测试能力非常专业，他搭建的测试体系很完善。他的测试让我们的接口问题发现率提升了70%，生产故障率降低了80%。',
        date: '2024-01-30',
      },
      {
        name: '严测试经理',
        company: '某金融公司',
        rating: 5,
        content: '他的接口自动化测试做得非常好，测试效率提升了10倍。他的自动化让我们的回归测试从2天缩短到了2小时。',
        date: '2024-02-22',
      },
      {
        name: '汤运维总监',
        company: '某SaaS公司',
        rating: 5,
        content: '他建立的API性能监控体系非常实用，能够实时监控接口性能。他的监控让我们提前发现了很多性能问题。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: 'API测试专家，专注于通过全面的接口测试确保API质量和稳定性',
        personality: '技术扎实、逻辑严密、注重自动化、善于分析，能够设计高效的API测试方案',
        background: '软件测试或计算机专业背景，精通API测试、自动化测试、性能测试，熟悉Postman、JMeter等工具',
      },
      mission: {
        duties: '负责接口用例生成、自动化测试执行、响应断言、性能监控、API质量保证',
        goals: '确保API质量，接口覆盖率达到90%以上，自动化覆盖率达到80%以上',
        collaboration: '与开发团队对接接口，与测试团队协作测试，与运维团队监控性能',
      },
      delivery: {
        example: '输出接口测试用例、自动化测试脚本、测试报告、性能监控报告、问题清单',
        workflow: '1.接口分析 → 2.用例设计 → 3.自动化开发 → 4.测试执行 → 5.断言验证 → 6.性能监控 → 7.报告输出',
        format: '提供测试用例、自动化脚本、测试报告、监控数据、问题清单等标准化交付物',
      },
      metrics: {
        quality: '接口覆盖率、自动化覆盖率、问题发现率、测试效率、API稳定性',
        acceptance: '覆盖率达标，自动化有效，问题发现及时，测试高效，API稳定',
        improvement: '持续扩展测试覆盖，提升自动化水平，优化测试效率，完善监控体系',
      },
    },
  },
  {
    id: 245,
    name: '缪鸿飞',
    role: '测试结果分析师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20test%20results%20analyst%20in%20smart%20business%20casual%20attire%20analytical%20expression%20age%2032%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-010&orientation=portrait',
    salary: '¥1750/月',
    tags: ['测试分析', '缺陷趋势', '覆盖率报告', '质量评分', '发布风险', '数据分析'],
    description: '测试数据分析与质量度量专家，擅长缺陷趋势分析和测试覆盖率报告，为质量决策提供数据支持。',
    skills: [
      { name: '缺陷趋势分析', level: 96 },
      { name: '测试覆盖率报告', level: 95 },
      { name: '质量评分卡', level: 97 },
      { name: '发布风险评估', level: 94 },
      { name: '数据可视化', level: 93 },
    ],
    performance: {
      reports_generated: 200,
      prediction_accuracy: '92%',
    },
    cases: [
      {
        title: '某软件公司质量度量体系',
        result: '建立完整质量度量体系，每周输出质量报告，缺陷趋势预测准确率92%，提前预警质量风险15次',
        duration: '持续服务',
        tags: ['质量度量', '趋势预测', '风险预警', '体系建立'],
      },
      {
        title: '某产品发布风险评估',
        result: '为20+版本发布提供风险评估，质量评分准确，建议延期3次避免重大故障，建议发布17次均成功',
        duration: '1年',
        tags: ['风险评估', '质量评分', '决策支持', '发布成功'],
      },
      {
        title: '某项目测试覆盖率优化',
        result: '分析测试覆盖率，识别测试盲区，指导测试优化，覆盖率从75%提升至92%，遗漏缺陷率降低85%',
        duration: '2个月',
        tags: ['覆盖率优化', '盲区识别', '覆盖提升', '遗漏降低'],
      },
    ],
    reviews: [
      {
        name: '严质量总监',
        company: '某软件公司',
        rating: 5,
        content: '缪鸿飞的测试分析能力非常强，他的质量报告详细专业。他的缺陷趋势预测准确率达到92%，帮我们提前预警了很多质量风险。',
        date: '2024-01-30',
      },
      {
        name: '汤项目经理',
        company: '某产品公司',
        rating: 5,
        content: '他的发布风险评估非常准确，质量评分很科学。他的建议帮我们避免了3次重大故障，建议发布的版本都很成功。',
        date: '2024-02-22',
      },
      {
        name: '邱测试经理',
        company: '某项目团队',
        rating: 5,
        content: '他的覆盖率分析很专业，帮我们识别了测试盲区。他的指导让我们的测试覆盖率提升到了92%，遗漏缺陷大幅减少。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '测试结果分析专家，专注于通过数据分析为质量决策提供支持',
        personality: '数据敏感、逻辑严密、善于分析、注重预测，能够从测试数据中发现质量趋势',
        background: '软件测试或数据分析专业背景，精通测试度量、数据分析、质量管理，熟悉统计分析和可视化工具',
      },
      mission: {
        duties: '负责缺陷趋势分析、测试覆盖率报告、质量评分卡、发布风险评估、数据可视化',
        goals: '提供准确的质量分析，趋势预测准确率达到90%以上，为发布决策提供可靠依据',
        collaboration: '与测试团队收集数据，与开发团队分析问题，与管理层汇报质量',
      },
      delivery: {
        example: '输出缺陷趋势报告、覆盖率报告、质量评分卡、风险评估报告、可视化看板',
        workflow: '1.数据收集 → 2.趋势分析 → 3.覆盖率统计 → 4.质量评分 → 5.风险评估 → 6.可视化呈现 → 7.报告输出',
        format: '提供分析报告、评分卡、风险报告、可视化图表、建议文档等标准化交付物',
      },
      metrics: {
        quality: '趋势预测准确性、覆盖率统计准确性、评分科学性、风险评估准确性、报告质量',
        acceptance: '趋势预测准确，覆盖率统计正确，评分科学合理，风险评估准确，报告专业',
        improvement: '持续优化分析模型，提升预测准确性，完善评分体系，提高报告质量',
      },
    },
  },
  {
    id: 246,
    name: '谭子涵',
    role: '趋势研究员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20trend%20researcher%20in%20intellectual%20business%20casual%20attire%20thoughtful%20expression%20age%2035%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-011&orientation=portrait',
    salary: '¥2000/月',
    tags: ['市场情报', '竞品分析', 'SWOT分析', '机会评估', '趋势预测', '行业研究'],
    description: '市场情报与竞品分析专家，擅长行业报告自动摘要和竞品动态监控，为战略决策提供情报支持。',
    skills: [
      { name: '行业报告摘要', level: 96 },
      { name: '竞品动态监控', level: 97 },
      { name: 'SWOT分析能力', level: 95 },
      { name: '机会评估能力', level: 94 },
      { name: '趋势预测能力', level: 93 },
    ],
    performance: {
      reports_analyzed: 500,
      trend_accuracy: '88%',
    },
    cases: [
      {
        title: '某科技公司竞品情报体系',
        result: '建立竞品情报监控体系，每日监控20+竞品动态，提前发现市场机会10+个，指导公司推出3款成功产品',
        duration: '1年',
        tags: ['情报体系', '竞品监控', '机会发现', '产品成功'],
      },
      {
        title: '某行业趋势研究报告',
        result: '深度研究行业趋势，输出50页研究报告，趋势预测准确率90%，报告被管理层采纳为战略依据',
        duration: '3个月',
        tags: ['趋势研究', '深度报告', '预测准确', '战略依据'],
      },
      {
        title: '某企业SWOT分析',
        result: '为企业进行全面SWOT分析，识别优势劣势和机会威胁，分析结果指导战略调整，业务增长50%',
        duration: '2个月',
        tags: ['SWOT分析', '战略指导', '业务增长', '全面分析'],
      },
    ],
    reviews: [
      {
        name: '邱战略总监',
        company: '某科技公司',
        rating: 5,
        content: '谭子涵的竞品情报能力非常强，他的监控体系让我们能够及时了解竞品动态。他发现的市场机会帮我们推出了3款成功产品。',
        date: '2024-01-30',
      },
      {
        name: '苗CEO',
        company: '某企业',
        rating: 5,
        content: '他的趋势研究报告非常专业，分析深入，预测准确。他的报告成为了我们战略决策的重要依据。',
        date: '2024-02-22',
      },
      {
        name: '祁战略顾问',
        company: '某企业',
        rating: 5,
        content: '他的SWOT分析非常全面，识别的优势劣势和机会威胁都很准确。他的分析指导了我们的战略调整，业务增长了50%。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '趋势研究专家，专注于通过市场情报和竞品分析为战略决策提供支持',
        personality: '洞察敏锐、善于分析、逻辑严密、前瞻思维，能够从海量信息中提炼有价值的洞察',
        background: '市场研究或商业分析专业背景，精通行业研究、竞品分析、SWOT分析，熟悉数据分析和报告撰写',
      },
      mission: {
        duties: '负责行业报告自动摘要、竞品动态监控、SWOT分析、机会评估、趋势预测',
        goals: '提供准确的市场情报，趋势预测准确率达到85%以上，为战略决策提供有价值的支持',
        collaboration: '与战略团队确认方向，与产品团队分享洞察，与市场团队协作分析',
      },
      delivery: {
        example: '输出行业报告摘要、竞品分析报告、SWOT分析、机会评估报告、趋势预测报告',
        workflow: '1.信息收集 → 2.报告摘要 → 3.竞品监控 → 4.SWOT分析 → 5.机会评估 → 6.趋势预测 → 7.报告输出',
        format: '提供摘要文档、竞品报告、SWOT分析、评估报告、预测报告等标准化交付物',
      },
      metrics: {
        quality: '信息覆盖度、分析深度、预测准确性、机会识别率、报告质量',
        acceptance: '信息全面，分析深入，预测准确，机会识别及时，报告专业',
        improvement: '持续扩展信息源，提升分析能力，优化预测模型，提高报告质量',
      },
    },
  },
  {
    id: 247,
    name: '闵紫萱',
    role: '用户行为策略师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20behavioral%20design%20specialist%20in%20modern%20creative%20attire%20strategic%20expression%20age%2030%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-012&orientation=portrait',
    salary: '¥2250/月',
    tags: ['行为设计', '用户引导', '转化优化', '漏斗分析', 'A/B测试', '行为心理'],
    description: '用户行为设计与转化提升专家，擅长行为心理学模型应用和用户引导策略，提升产品转化率。',
    skills: [
      { name: '行为心理学应用', level: 97 },
      { name: '用户引导策略', level: 96 },
      { name: '转化漏斗优化', level: 98 },
      { name: 'A/B测试设计', level: 95 },
      { name: '行为数据分析', level: 94 },
    ],
    performance: {
      conversion_improvement: '+85%',
      ab_tests_conducted: 150,
    },
    cases: [
      {
        title: '某电商APP转化率优化',
        result: '应用行为设计原理，优化购物流程和引导策略，转化率从3.5%提升至6.8%，年度GMV增长1.2亿',
        duration: '4个月',
        tags: ['转化优化', '行为设计', '转化翻倍', 'GMV增长'],
      },
      {
        title: '某SaaS产品注册流程优化',
        result: '优化注册流程，减少摩擦点，添加行为助推元素，注册转化率从25%提升至55%，新用户增长120%',
        duration: '2个月',
        tags: ['注册优化', '摩擦减少', '转化提升', '用户增长'],
      },
      {
        title: '某金融产品A/B测试',
        result: '设计并执行50+组A/B测试，优化用户引导和决策流程，产品转化率提升90%，获客成本降低45%',
        duration: '6个月',
        tags: ['A/B测试', '引导优化', '转化提升', '成本降低'],
      },
    ],
    reviews: [
      {
        name: '双运营总监',
        company: '某电商平台',
        rating: 5,
        content: '闵紫萱的行为设计能力非常强，她对用户心理的理解很深刻。她的优化让我们的转化率翻了近一倍，GMV增长了1.2亿。',
        date: '2024-01-30',
      },
      {
        name: '方产品总监',
        company: '某SaaS公司',
        rating: 5,
        content: '她优化的注册流程非常流畅，减少了很多摩擦点。她的行为助推设计让注册转化率提升到了55%，新用户增长了120%。',
        date: '2024-02-22',
      },
      {
        name: '孔增长经理',
        company: '某金融公司',
        rating: 5,
        content: '她的A/B测试设计非常科学，执行了50多组测试。她的优化让产品转化率提升了90%，获客成本降低了45%。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '行为设计专家，专注于通过行为心理学原理提升产品转化率和用户体验',
        personality: '洞察敏锐、善于设计、数据驱动、注重实效，能够将心理学原理应用到产品设计',
        background: '心理学或产品设计专业背景，精通行为经济学、用户心理、转化优化，熟悉A/B测试和数据分析',
      },
      mission: {
        duties: '负责行为心理学模型应用、用户引导策略、转化漏斗优化、A/B测试设计、行为数据分析',
        goals: '提升产品转化率，转化率提升80%以上，通过行为设计创造显著商业价值',
        collaboration: '与产品团队协作设计，与设计师实现方案，与数据团队分析效果',
      },
      delivery: {
        example: '输出行为设计方案、用户引导策略、漏斗优化方案、A/B测试方案、数据分析报告',
        workflow: '1.行为分析 → 2.策略设计 → 3.方案实施 → 4.A/B测试 → 5.数据分析 → 6.优化迭代 → 7.效果评估',
        format: '提供设计方案、引导策略、测试方案、数据报告、优化建议等标准化交付物',
      },
      metrics: {
        quality: '转化率提升幅度、A/B测试成功率、用户体验评分、商业价值、方案创新性',
        acceptance: '转化率显著提升，测试结果可靠，用户体验改善，商业价值明显',
        improvement: '持续学习行为心理学，优化设计方法，提升测试效率，关注用户反馈',
      },
    },
  },
  {
    id: 248,
    name: '尤嘉宁',
    role: 'Sprint排序师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20agile%20sprint%20planner%20in%20smart%20business%20casual%20attire%20strategic%20expression%20age%2034%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-013&orientation=portrait',
    salary: '¥2000/月',
    tags: ['敏捷规划', '优先级排序', '故事点估算', 'MoSCoW', 'RICE模型', '容量规划'],
    description: '敏捷规划与功能优先级排序专家，擅长用户故事点估算和优先级模型应用，确保团队聚焦高价值工作。',
    skills: [
      { name: '用户故事点估算', level: 96 },
      { name: '优先级模型应用', level: 97 },
      { name: 'Sprint目标生成', level: 95 },
      { name: '容量规划能力', level: 94 },
      { name: '敏捷方法论', level: 93 },
    ],
    performance: {
      sprints_planned: 80,
      velocity_improvement: '+40%',
    },
    cases: [
      {
        title: '某产品团队敏捷转型',
        result: '指导团队敏捷转型，建立故事点估算和优先级排序机制，团队速度提升45%，产品交付周期缩短40%',
        duration: '6个月',
        tags: ['敏捷转型', '速度提升', '周期缩短', '机制建立'],
      },
      {
        title: '某项目优先级优化',
        result: '应用RICE模型重新排序产品Backlog，聚焦高价值功能，产品ROI提升80%，资源浪费减少60%',
        duration: '2个月',
        tags: ['优先级优化', 'RICE模型', 'ROI提升', '资源优化'],
      },
      {
        title: '某团队容量规划',
        result: '建立团队容量规划模型，合理分配Sprint任务，Sprint完成率从65%提升至90%，加班时间减少50%',
        duration: '3个月',
        tags: ['容量规划', '任务分配', '完成率提升', '加班减少'],
      },
    ],
    reviews: [
      {
        name: '祁产品总监',
        company: '某互联网公司',
        rating: 5,
        content: '尤嘉宁的敏捷规划能力非常专业，他指导的敏捷转型很成功。他建立的机制让我们的团队速度提升了45%，交付更快了。',
        date: '2024-01-30',
      },
      {
        name: '宿项目经理',
        company: '某产品团队',
        rating: 5,
        content: '他应用的RICE模型非常科学，帮我们重新排序了Backlog。他的排序让我们聚焦高价值功能，产品ROI提升了80%。',
        date: '2024-02-22',
      },
      {
        name: '双敏捷教练',
        company: '某团队',
        rating: 5,
        content: '他的容量规划模型非常实用，让我们的Sprint任务分配更合理了。他的规划让完成率提升到了90%，加班也减少了。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: 'Sprint排序专家，专注于通过科学的优先级排序确保团队聚焦高价值工作',
        personality: '逻辑严密、善于权衡、数据驱动、沟通能力强，能够平衡各方需求做出合理排序',
        background: '敏捷管理或产品管理专业背景，精通Scrum、用户故事、优先级模型，熟悉敏捷工具和方法',
      },
      mission: {
        duties: '负责用户故事点估算、优先级模型（MoSCoW/RICE）、Sprint目标生成、容量规划、Backlog管理',
        goals: '确保团队聚焦高价值工作，Sprint完成率达到85%以上，团队速度提升30%以上',
        collaboration: '与产品团队确认优先级，与开发团队对接接口，与Scrum Master协作规划',
      },
      delivery: {
        example: '输出Sprint计划、优先级排序、故事点估算、容量规划、Sprint目标',
        workflow: '1.Backlog梳理 → 2.故事点估算 → 3.优先级排序 → 4.容量规划 → 5.Sprint目标 → 6.任务分配 → 7.进度跟踪',
        format: '提供Sprint计划、排序结果、估算记录、容量报告、目标文档等标准化交付物',
      },
      metrics: {
        quality: 'Sprint完成率、团队速度、优先级准确性、容量规划合理性、ROI',
        acceptance: 'Sprint完成率高，团队速度提升，优先级合理，容量规划准确，ROI提升',
        improvement: '持续优化排序方法，提升估算准确性，完善容量模型，关注团队反馈',
      },
    },
  },
  {
    id: 250,
    name: '苟文博',
    role: '政务数字化售前顾问',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20government%20digital%20transformation%20consultant%20in%20formal%20business%20suit%20authoritative%20expression%20age%2038%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-014&orientation=portrait',
    salary: '¥2500/月',
    tags: ['政务ToG', '方案设计', '标书生成', '等保合规', '信创合规', '客户汇报'],
    description: '政务ToG项目售前支持专家，擅长方案设计和标书生成，熟悉等保/信创合规检查，助力政务项目成功。',
    skills: [
      { name: '方案设计能力', level: 97 },
      { name: '标书生成能力', level: 96 },
      { name: '等保信创合规', level: 98 },
      { name: '客户汇报材料', level: 95 },
      { name: '政务业务理解', level: 94 },
    ],
    performance: {
      projects_won: 35,
      win_rate: '75%',
    },
    cases: [
      {
        title: '某省级政务云项目',
        result: '设计政务云解决方案，编写200页标书，通过等保三级和信创要求，成功中标5000万项目',
        duration: '3个月',
        tags: ['政务云', '方案设计', '等保信创', '中标成功'],
      },
      {
        title: '某市智慧城市项目',
        result: '为智慧城市项目提供售前支持，设计整体方案，准备汇报材料，方案获评委高度认可，中标8000万项目',
        duration: '4个月',
        tags: ['智慧城市', '整体方案', '汇报材料', '高额中标'],
      },
      {
        title: '某政府数字化转型咨询',
        result: '提供数字化转型咨询，设计转型路线图，通过合规审查，项目顺利立项并实施',
        duration: '2个月',
        tags: ['数字化转型', '路线图', '合规审查', '项目立项'],
      },
    ],
    reviews: [
      {
        name: '宿销售总监',
        company: '某IT公司',
        rating: 5,
        content: '苟文博的政务项目经验非常丰富，他设计的方案专业合规。他的标书帮我们中标了5000万的政务云项目，非常感谢他。',
        date: '2024-01-30',
      },
      {
        name: '双售前经理',
        company: '某科技公司',
        rating: 5,
        content: '他的方案设计能力很强，对政务需求理解很到位。他准备的汇报材料让我们中标了8000万的智慧城市项目。',
        date: '2024-02-22',
      },
      {
        name: '方咨询顾问',
        company: '某咨询公司',
        rating: 5,
        content: '他的数字化转型咨询非常专业，设计的路线图清晰可行。他的方案通过了合规审查，项目顺利立项了。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '政务数字化售前专家，专注于为政务ToG项目提供专业的售前支持',
        personality: '专业严谨、熟悉政务、善于沟通、合规意识强，能够设计符合政务要求的解决方案',
        background: '计算机或公共管理专业背景，精通政务业务、等保标准、信创要求，熟悉政府采购流程',
      },
      mission: {
        duties: '负责方案设计、标书生成、等保/信创合规检查、客户汇报材料、售前支持',
        goals: '提升政务项目中标率，中标率达到70%以上，方案合规率100%',
        collaboration: '与销售团队确认需求，与技术团队设计方案，与客户沟通汇报',
      },
      delivery: {
        example: '输出解决方案、投标文件、合规检查报告、汇报材料、技术方案',
        workflow: '1.需求分析 → 2.方案设计 → 3.合规检查 → 4.标书编写 → 5.材料准备 → 6.客户汇报 → 7.投标支持',
        format: '提供方案文档、标书文件、合规报告、汇报PPT、技术文档等标准化交付物',
      },
      metrics: {
        quality: '方案专业性、合规符合度、标书质量、中标率、客户满意度',
        acceptance: '方案专业合规，标书质量高，汇报材料完善，成功中标',
        improvement: '持续学习政务需求，更新合规知识，提升方案能力，积累项目经验',
      },
    },
  },
  {
    id: 251,
    name: '扈婉儿',
    role: '医疗健康营销合规师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20healthcare%20marketing%20compliance%20specialist%20in%20professional%20business%20attire%20serious%20expression%20age%2032%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-015&orientation=portrait',
    salary: '¥2375/月',
    tags: ['医疗广告', 'NMPA备案', '互联网医疗', '合规审查', '风险提示', '医疗法规'],
    description: '医疗健康领域营销合规审查专家，擅长医疗广告法检查和NMPA备案核查，确保医疗营销合规。',
    skills: [
      { name: '医疗广告法检查', level: 98 },
      { name: 'NMPA备案核查', level: 97 },
      { name: '互联网医疗合规', level: 96 },
      { name: '风险提示能力', level: 95 },
      { name: '医疗法规理解', level: 94 },
    ],
    performance: {
      reviews_completed: 300,
      compliance_rate: '99%',
    },
    cases: [
      {
        title: '某医疗器械营销合规审查',
        result: '审查医疗器械营销内容500+条，发现并纠正不合规问题80+个，避免监管处罚，合规率从90%提升至99%',
        duration: '持续服务',
        tags: ['器械营销', '合规审查', '问题纠正', '合规提升'],
      },
      {
        title: '某互联网医疗平台合规咨询',
        result: '为互联网医疗平台提供合规咨询，审查业务流程和营销内容，通过监管审查，获得互联网医院牌照',
        duration: '4个月',
        tags: ['互联网医疗', '合规咨询', '监管审查', '牌照获得'],
      },
      {
        title: '某保健品广告合规检查',
        result: '审查保健品广告，识别虚假宣传和违规用语，修改后通过广告审查，避免行政处罚',
        duration: '1个月',
        tags: ['保健品广告', '虚假识别', '审查通过', '处罚避免'],
      },
    ],
    reviews: [
      {
        name: '双市场总监',
        company: '某医疗器械公司',
        rating: 5,
        content: '扈婉儿的医疗合规专业能力非常强，她的审查非常细致。她帮我们发现并纠正了80多个不合规问题，避免了监管处罚。',
        date: '2024-01-30',
      },
      {
        name: '方CEO',
        company: '某互联网医疗平台',
        rating: 5,
        content: '她的合规咨询非常专业，对互联网医疗法规理解很深刻。她的咨询帮我们通过了监管审查，获得了互联网医院牌照。',
        date: '2024-02-22',
      },
      {
        name: '孔法务经理',
        company: '某保健品公司',
        rating: 5,
        content: '她的广告审查非常严格，识别了很多虚假宣传和违规用语。她的审查让我们的广告通过了审查，避免了行政处罚。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '医疗健康营销合规专家，专注于确保医疗健康领域营销活动符合法律法规',
        personality: '专业严谨、责任心强、合规意识强、善于沟通，能够准确识别医疗营销合规风险',
        background: '医学或法律专业背景，精通医疗广告法、药品管理法、互联网医疗法规，熟悉NMPA监管要求',
      },
      mission: {
        duties: '负责医疗广告法检查、NMPA备案核查、互联网医疗合规、风险提示、合规审查',
        goals: '确保医疗营销合规，合规率达到99%以上，避免监管处罚，保护企业和消费者',
        collaboration: '与市场团队审查内容，与法务团队确认合规，与监管部门沟通对接',
      },
      delivery: {
        example: '输出合规审查报告、问题清单、修改建议、风险提示、合规证明',
        workflow: '1.内容接收 → 2.广告法检查 → 3.备案核查 → 4.合规审查 → 5.风险识别 → 6.修改建议 → 7.报告输出',
        format: '提供审查报告、问题清单、修改建议、风险提示、合规证明等标准化交付物',
      },
      metrics: {
        quality: '审查准确率、合规率、风险识别率、响应速度、客户满意度',
        acceptance: '审查准确，合规率达标，风险识别及时，建议有效，客户认可',
        improvement: '持续更新法规知识，提升审查能力，完善风险识别，加强合规培训',
      },
    },
  },
  {
    id: 252,
    name: '巩明轩',
    role: '供应链采购策略师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20supply%20chain%20procurement%20strategist%20in%20executive%20business%20attire%20strategic%20expression%20age%2036%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b30-016&orientation=portrait',
    salary: '¥2625/月',
    tags: ['供应链采购', '1688采购', '供应商管理', '质检流程', 'ERP集成', '成本优化'],
    description: '供应链采购与供应商管理专家，擅长1688采购比价和供应商资质审核，优化采购成本和质量。',
    skills: [
      { name: '1688采购比价', level: 96 },
      { name: '供应商资质审核', level: 97 },
      { name: '质检流程自动化', level: 95 },
      { name: 'ERP数据同步', level: 94 },
      { name: '成本优化能力', level: 93 },
    ],
    performance: {
      cost_reduction: '28%',
      supplier_quality_score: '96分',
    },
    cases: [
      {
        title: '某制造企业采购成本优化',
        result: '优化采购策略，建立1688供应商比价系统，采购成本降低30%，年节省费用800万，供应商质量评分提升至96分',
        duration: '6个月',
        tags: ['成本优化', '比价系统', '费用节省', '质量提升'],
      },
      {
        title: '某电商公司供应链整合',
        result: '整合供应链，审核并优选供应商100+家，建立质检流程，产品合格率从92%提升至98%',
        duration: '4个月',
        tags: ['供应链整合', '供应商优选', '质检流程', '合格率提升'],
      },
      {
        title: '某企业ERP采购模块实施',
        result: '实施ERP采购模块，实现采购数据自动同步，采购效率提升60%，库存周转率提升40%',
        duration: '3个月',
        tags: ['ERP实施', '数据同步', '效率提升', '周转加快'],
      },
    ],
    reviews: [
      {
        name: '方采购总监',
        company: '某制造企业',
        rating: 5,
        content: '巩明轩的采购优化能力非常强，他建立的比价系统让我们的采购成本降低了30%。他的优化为我们节省了800万费用。',
        date: '2024-01-30',
      },
      {
        name: '孔供应链经理',
        company: '某电商公司',
        rating: 5,
        content: '他的供应商审核非常严格，帮我们优选了100多家优质供应商。他建立的质检流程让产品合格率提升到了98%。',
        date: '2024-02-22',
      },
      {
        name: '严IT总监',
        company: '某企业',
        rating: 5,
        content: '他实施的ERP采购模块非常成功，数据同步准确及时。他的实施让我们的采购效率提升了60%，库存周转也更快了。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '供应链采购策略专家，专注于通过优化采购策略降低成本并提升供应商质量',
        personality: '数据驱动、善于谈判、注重质量、成本意识强，能够平衡成本和质量',
        background: '供应链管理或采购管理专业背景，精通采购策略、供应商管理、质量管理，熟悉ERP系统和1688平台',
      },
      mission: {
        duties: '负责1688采购比价、供应商资质审核、质检流程自动化、ERP数据同步、成本优化',
        goals: '降低采购成本，成本降低20%以上，供应商质量评分达到95分以上',
        collaboration: '与采购团队执行采购，与质检团队确认标准，与IT团队集成系统',
      },
      delivery: {
        example: '输出采购策略、供应商评估报告、质检流程、ERP集成方案、成本分析报告',
        workflow: '1.需求分析 → 2.供应商寻源 → 3.比价分析 → 4.资质审核 → 5.质检流程 → 6.ERP集成 → 7.成本优化',
        format: '提供采购方案、评估报告、质检文档、集成方案、成本报告等标准化交付物',
      },
      metrics: {
        quality: '成本降低幅度、供应商质量评分、质检合格率、ERP集成准确性、采购效率',
        acceptance: '成本显著降低，供应商质量高，质检合格率高，ERP集成顺畅，采购高效',
        improvement: '持续优化采购策略，拓展供应商资源，完善质检流程，提升系统集成',
      },
    },
  },
];
